import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import { TopTimesTrackStats } from "stats/Track/TopTimes/TopTimesTrackStats";

export const TrackTopTimesStatTableColumns: StatTableColumn<TopTimesTrackStats>[] =
  [
    {
      type: "Text",
      textGetter: (arg) => arg.rankText,
      subTextGetter: undefined,
    },
    {
      type: "OrgLogoName",
      header: "Driver",
      nameGetter: (arg) => arg.driverName,
      orgIdGetter: (arg) => arg.orgId,
      smallerSize: true,
    },
    {
      type: "Time",
      header: "Race Time",
      timeGetter: (arg) => arg.timeMs,
    },
    {
      type: "DateTime",
      header: "Date Set",
      dateTimeGetter: (arg) => arg.dateMs,
      dateFormatGetter: () => "do MMM yyyy",
    },
  ];
